/* eslint-disable i18n/no-russian-character */
const ruSystem = {
    connection: {
        isOfflineConfirm: "Интернет-соединение не обнаружено. Всё равно перейти по ссылке?",
        offlineRegime: "Оффлайн режим",
    },
    data: {
        errors: {
            forbidden: "Действие запрещено",
        },
    },
    serviceWorker: {
        update: "Доступна новая версия портала. Обновимся?",
    },
    dateTime: {
        errors: {
            invalidDate: "Неверная дата",
            endDateBeforeStartDate: "Дата окончания не может быть раньше даты начала",
        },
    },
    biometric: {
        error: "❌ Ошибка биометрической аутентификации",
    },
};

export default ruSystem;
